import React from 'react';

import { Helmet } from 'react-helmet';

import { Typography } from '@mui/material';

import ChatterFeed from './Chatter/ChatterFeed';
import { CHATTER_OPPORTUNITY_SEED_POSTS } from './Chatter/opportunitySeedPosts';

export default function OfferBuilderFeedPage() {
  return (
    <>
      <Helmet>
        <title>Feed | Offer Builder</title>
      </Helmet>

      <Typography variant="h4" sx={{ mb: 2 }}>
        Feed
      </Typography>
      <ChatterFeed initialPosts={CHATTER_OPPORTUNITY_SEED_POSTS} scopeLabel="opportunity" />
    </>
  );
}
